import { createStore } from 'redux';
import rootReducer from './reducers';

/**
 * Создание хранилища Redux с корневым редьюсером
 */
const store = createStore(
  rootReducer,
  // Если нужно использовать Redux DevTools в браузере
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store; 